export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./lk-course-rate.vue?vue&type=template&id=16c9fb26&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/lk-course/lk-course-rate/lk-course-rate.vue?vue&type=template&id=16c9fb26&
// module id = 1506
// module chunks = 0